import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App'
import { FaArrowRightLong } from "react-icons/fa6";
import box from '../../assets/img/box.png'
import policy from '../../assets/img/policy.png'
import money from '../../assets/img/money.png'
import security from '../../assets/img/security.png'
import Topic0 from '../../components/help/shipping/topic0';
import Topic1 from '../../components/help/shipping/topic1';
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

const Shipping = () => {

  const { user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')
  const [topic, setTopic] = useState(0)
  const navigate = useNavigate()

  return (
    <div className="innerContainer mx-auto flex gap-x-10 py-[104px] md:py-[106px]">
      <div className="w-full">
        <div className="flex flex-col gap-8 h-full justify-between">
          <div className="title text-lg xl:text-xl font-medium flex gap-5 items-center cursor-pointer hover:text-emerald-600 transition-[] w-fit" onClick={() => navigate('/hjælp')}>
            <IoIosArrowBack />
            <h2>Forsendelse</h2>
          </div>
          <div className="flex flex-col lg:flex-row gap-y-5 gap-x-16">
            <div className="flex-[1] shadow-lg p-5 flex flex-col gap-2">
                <h2 className="text-base p-5">Relevante emner</h2>
                <div className="questions list-none">
                    <li className={"p-5 w-full cursor-pointer font-medium transition-[] flex justify-between items-center" + (topic === 0 ? " bg-neutral-100" : " group hover:bg-neutral-100")} onClick={() => (topic !== 0) ? setTopic(0) : ""}>
                        Afsendelse af en bog
                        <FaArrowRightLong className="group-hover:-translate-x-2 transition-[]" />
                    </li>
                    <li className={"p-5 w-full cursor-pointer font-medium transition-[] flex justify-between items-center" + (topic === 1 ? " bg-neutral-100" : " group hover:bg-neutral-100")} onClick={() => (topic !== 1) ? setTopic(1) : ""}>
                        Sporing af en pakke
                        <FaArrowRightLong className="group-hover:-translate-x-2 transition-[]" />
                    </li>
                </div>
            </div>
            <div className="flex-[2]">
                {(topic === 0) ?
                    <Topic0 />
                :
                    <Topic1 />
                }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Shipping